import React from 'react';
import { useSelector } from 'react-redux';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormValues } from '../../FirmSettings.meta';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { selectIsOrionAdviser } from '../../../../../AdviserArea/AdviserAreaSelector';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const PersonalFinances = ({ formBag, ...rest }: Props) => {
  const isOrionAdviser = useSelector(selectIsOrionAdviser);

  if (!isOrionAdviser) {
    return null;
  }

  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Personal Finances" />

      <Toggle {...formBag.register('allowPersonalFinancesCsvExport')} mt="24">
        Allow the ability to export grids under Personal Finances
      </Toggle>

      <Toggle {...formBag.register('allowAccountNickname')} mt="24">
        Allow the Ability to Update Account Nicknames
      </Toggle>
    </Box>
  );
};
